export default __webpack_public_path__ + "static/media/empty-timeline.4208b5b1.svg";